/* eslint-disable import/prefer-default-export */
export const SOCKET_LEAD_UPDATED = 'SOCKET_leadUpdated';
